<template>
    <div id="app">
        <header>
            <h1>KekeSales</h1>

            <div v-if="hasFetchedUser && authenticatedUser" class="header-user-area">
                <span class="username">{{ authenticatedUser.username }}</span>
                <button v-if="isLoggedIn" @click.prevent="logout">Logga ut</button>
            </div>
        </header>
        <main>
            <nav id="nav">
                <router-link to="/" v-if="isLoggedIn">Översikt</router-link>
                <router-link to="/store/new" v-if="isLoggedIn">Ny butik</router-link>
            </nav>
            <div id="content" v-if="hasFetchedUser">
                <router-view/>
            </div>
            <div id="app_loading" v-else>
                Laddar...
            </div>
        </main>
    </div>
</template>

<script>
import { HTTP } from './http'
import { mapActions, mapGetters, mapState} from 'vuex'

export default {
    name: 'app',
    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn'
        }),
        ...mapState('auth', {
            hasFetchedUser: state => state.hasFetchedUser,
            authenticatedUser: state => state.authenticatedUser,
            authRedirect: state => state.authRedirect
        })
    },
    watch: {
        isLoggedIn(newStatus) {
            if (!this.hasFetchedUser) {
                return;
            }

            this.$router.replace(newStatus ? this.authRedirect : '/login');
        }
    },
    methods: {
        ...mapActions({
            'logout': 'auth/logout'
        })
    },
    mounted() {
        this.$store.dispatch('auth/getMe');

        HTTP.interceptors.response.use(undefined, err => {
            if (err.response.status === 401) {
                this.logout();
                return;
            }

            return Promise.reject(err);
        });
    }
}
</script>
